import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { jwtDecode } from "jwt-decode"; // Certifique-se de que essa dependência está instalada
import apiClient from "../../api/api-client";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const initializeAuth = useCallback(async () => {
    setLoading(true);
    const accessToken = localStorage.getItem("accessToken");
    const storedRefreshToken = localStorage.getItem("refreshToken");
  
    if (!accessToken || !storedRefreshToken) {
      setUser(null);
      setLoading(false);
      return;
    }
  
    try {
      const decodedToken = jwtDecode(accessToken);
      const isExpired = decodedToken.exp < Date.now() / 1000;

      if (isExpired) {
        const response = await apiClient.post("/auth/refresh-token", { 
          accessToken: accessToken,
          refreshToken: storedRefreshToken
        });

        if(response){
          logout();
        }

        if (response?.accessToken && response?.refreshToken) {
          localStorage.setItem("accessToken", response.data.accessToken);
          localStorage.setItem("refreshToken", response.data.refreshToken);
          
          setUser(response);
        } else {
          throw new Error("Resposta de refresh inválida");
        }
      }else{

        const response = await apiClient.get(`usuarios/${decodedToken.usuarioId}`);
        setUser(response.data);
      }      
    } catch (error) {
      console.error("Erro ao renovar autenticação:", error);
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    initializeAuth();
  }, [initializeAuth]);

  const login = (credentials) => {
    localStorage.setItem("accessToken", credentials.accessToken);
    localStorage.setItem('refreshToken', credentials.refreshToken);
    setUser(credentials);
  };

  const logout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    setUser(null);
  };

  const isAuthenticated = !!user;

  return (
    <AuthContext.Provider value={{ user, login, logout, isAuthenticated, loading }}>
      {!loading && children} {/* Só renderiza os filhos após terminar o carregamento */}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
